<h1 mat-dialog-title>{{ data.kanbanViewName }}</h1>

<div mat-dialog-content class="kc-content">
  <p class="kc-hint" [class.kc-hint-locked]="isReadOnly">
    <mat-icon class="kc-hint-icon">{{ isReadOnly ? 'lock' : 'info' }}</mat-icon>
    <span>{{ (isReadOnly ? 'page.kanbanConfig.readOnlyHint' : 'page.kanbanConfig.mapHint') | translate }}</span>
  </p>

  <div *ngIf="loading()" class="kc-board" aria-hidden="true">
    <div class="kc-skeleton kc-skeleton-palette"></div>
    <div class="kc-columns-row kc-skeleton-row">
      <div *ngFor="let placeholder of [0, 1, 2]" class="kc-skeleton kc-skeleton-col"></div>
    </div>
  </div>

  <div *ngIf="!loading()" class="kc-board" [class.kc-board-readonly]="isReadOnly">
    <aside class="kc-palette" *ngIf="!isReadOnly">
      <div class="kc-palette-header">
        <span class="kc-section-title">{{ 'page.kanbanConfig.statuses' | translate }}</span>
        <app-count-badge *ngIf="unassignedSteps().length" [count]="unassignedSteps().length"></app-count-badge>
      </div>
      <div
        class="kc-palette-list"
        [id]="paletteListId"
        cdkDropList
        [cdkDropListData]="unassignedSteps()"
        [cdkDropListConnectedTo]="columnListIds()"
        (cdkDropListDropped)="onStatusDrop($event, -1)"
      >
        <div *ngFor="let step of unassignedSteps()" class="kc-chip" cdkDrag [cdkDragData]="step">
          <app-status-category-badge
            [statusCategory]="step.statusCategory"
            [label]="step.isDefault ? ('system.label.' + step.name | translate) : step.name"
          ></app-status-category-badge>
        </div>
        <div class="kc-palette-empty" *ngIf="!unassignedSteps().length">
          <div class="kc-palette-empty-icon">
            <mat-icon>done_all</mat-icon>
          </div>
          <span>{{ 'page.kanbanConfig.allAssigned' | translate }}</span>
        </div>
      </div>
    </aside>

    <div
      class="kc-columns-row"
      id="kc-columns-row"
      cdkDropList
      cdkDropListOrientation="horizontal"
      [cdkDropListDisabled]="isReadOnly"
      [cdkDropListData]="columns()"
      (cdkDropListDropped)="dropColumn($event)"
    >
      @for (column of columnViews(); track $index; let i = $index) {
        <div class="kc-col" cdkDrag [cdkDragDisabled]="isReadOnly">
          <div class="kc-col-header">
            <mat-icon *ngIf="!isReadOnly" class="kc-drag-handle" cdkDragHandle>drag_indicator</mat-icon>
            <mat-form-field appearance="outline" class="kc-title-field" subscriptSizing="dynamic">
              <mat-label>{{ 'page.kanbanConfig.columnTitle' | translate }}</mat-label>
              <input
                matInput
                [ngModel]="column.title"
                (ngModelChange)="setColumnTitle(i, $event)"
                [name]="'title-' + i"
                maxlength="255"
                [readonly]="isReadOnly"
              />
            </mat-form-field>
            <button *ngIf="!isReadOnly" mat-mini-fab type="button" class="v-middle kc-remove" (click)="removeColumn(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>

          <div
            class="kc-col-body"
            [id]="columnListPrefix + i"
            cdkDropList
            [cdkDropListDisabled]="isReadOnly"
            [cdkDropListData]="column.steps"
            [cdkDropListConnectedTo]="columnListIds()"
            (cdkDropListDropped)="onStatusDrop($event, i)"
          >
            <div
              *ngFor="let step of column.steps"
              class="kc-chip"
              cdkDrag
              [cdkDragDisabled]="isReadOnly"
              [cdkDragData]="step"
            >
              <app-status-category-badge
                [statusCategory]="step.statusCategory"
                [label]="step.isDefault ? ('system.label.' + step.name | translate) : step.name"
              ></app-status-category-badge>
            </div>
            <div class="kc-col-empty" *ngIf="!column.steps.length">
              {{ 'page.kanbanConfig.dropHere' | translate }}
            </div>
          </div>
        </div>
      }

      <button *ngIf="!isReadOnly" type="button" class="kc-add-column" (click)="addColumn()">
        <span class="kc-add-column-icon">
          <mat-icon>add</mat-icon>
        </span>
        <span>{{ 'page.kanbanConfig.addColumn' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<mat-dialog-actions align="end">
  <button matButton="tonal" [disabled]="saving()" (click)="dialogRef.close(false)">
    {{ (isReadOnly ? 'button.close' : 'button.cancel') | translate }}
  </button>
  <button *ngIf="!isReadOnly" mat-flat-button [disabled]="loading() || saving()" (click)="save()">
    {{ 'button.saveChanges' | translate }}
  </button>
</mat-dialog-actions>
